import React, { Component } from "react";
import { applyDataTable } from '../../custom/dataTable';
import del from '../../../assets/img/svg/Del.svg';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import upload from '../../../assets/img/svg/upload.svg';
import $ from 'jquery';
import Divider from '@material-ui/core/Divider';
import PropTypes from 'prop-types';
import styles from "../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import Delete from '../../../assets/img/svg/delete.svg';
import moment from "moment";
import axios from "axios";
import API from "../../../_helpers/endpointService"
import { getSettingsFormat } from "../../../actions/SettingsAction"
import { Tabs, Tab, AppBar, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import View from '../../../assets/img/svg/view.svg';
import EasyEdit from 'react-easy-edit';
import active from '../../../assets/img/svg/active.svg';
import deactive from '../../../assets/img/svg/deactive.svg';
import { CssTextField } from "../../custom/textField"

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

class CorrectiveAction extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            ProjectId: 0,
            UserRole: "",
            isMobile: false,
            value: 0,
            TypeId: 0,
            render: false,
            documentlist: {
                'projectId': 0,
                'typeId': 0,
            },
            displaydoc: {
                'FileUrl': '',
                'ProjectDocumentId': 0,
                'DocumentDate': '',
                'DocumentName': '',
                'Comments': ''
            },
            postdocs: {
                'ActionBy': '',
                'ActionDate': '',
                'ProjectDocumentId': 0,
                'ProjectId': 0,
                'Comments': '',
                'DocumentDate': '',
                'TypeId': 0,
                'ProjectDocumentTypeId': 0,
            },
            putcomments: {
                "Projectdocumentsid": 0,
                "Comments": "",
                "ActionBy": ""
            }
        }
    }

    componentDidMount() {
        this.getTypes("DocumentTypes")
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.postdocs.ProjectId = localStorage.getItem("DashId");
        this.state.documentlist.projectId = localStorage.getItem("DashId");
        this.state.putcomments.ActionBy = localStorage.getItem("UserRoles");
        this.state.postdocs.ActionBy = localStorage.getItem("UserRoles");
        this.state.postdocs.ActionDate = moment(new Date()).format('YYYY-MM-DD');
        this.state.postdocs.DocumentDate = moment(new Date()).format('YYYY-MM-DD');
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    };

    getTypes = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/type?type=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (response.data.length > 0) {
                        let type = response.data.filter((val) => val.Name == "CorrectiveActions")
                        // this.state.tableData.Typeid = type[0].Id;
                        this.state.documentlist.typeId = type[0].Id;
                        this.state.postdocs.TypeId = type[0].Id;
                        this.state.TypeId = type[0].Id;
                        this.setState({})
                    }
                    this.documents(this.state.documentlist);
                    // this.dataTable(this.state.tableData);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    sidebar = () => {
        this.props.navigate("/sidebaryarddocument");
    }

    documents = (data) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/List?projectId=' + data.projectId + '&typeId=' + data.typeId;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.render = true;
                    this.setState({})
                    if (response?.data) {
                        if (response?.data.length == 1) {
                            this.state.displaydoc.FileUrl = response.data[0].Attachment.FileUrl;
                            this.state.displaydoc.ProjectDocumentId = response.data[0].ProjectDocumentId;
                            this.state.displaydoc.DocumentDate = response.data[0].DocumentDate;
                            this.state.displaydoc.DocumentName = response.data[0].DocumentName;
                            this.state.displaydoc.Comments = response.data[0].Comments;
                        }
                    }
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Corrective1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#CorrectiveActions1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#CorrectiveActions").addClass("d-none");
        $("#CorrectiveActions").removeClass("d-block");
        $("#CA .MuiListItemText-primary").removeClass("fw-bolder")
        $("#CAL").removeClass("active-color")
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        $("#Corrective1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#CorrectiveActions1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#CorrectiveActions").removeClass("d-none");
        $("#CorrectiveActions").addClass("d-block");
        $("#CA .MuiListItemText-primary").addClass("fw-bolder")
        $("#CAL").addClass("active-color")
    };

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        if (newValue == 0) {
            this.state.render = false;
            this.setState({})
            this.getTypes("DocumentTypes")
        }
        if (newValue == 1) {
            this.gethistory(this.state.ProjectId)
        }
    };

    gethistory = (id) => {
        let apiUrl = API.HISTORY_LOG + id + '?name=CorrectiveActions'
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "HISTORY_LOG", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    OpenPopup = () => {
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide")
        this.DeleteOthersApi(this.state.displaydoc.ProjectDocumentId, this.state.UserRole)
    }

    DeleteOthersApi = (data, role) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/projectDocumentIds?projectDocumentIds=' + data + '&actionby=' + role;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.documents(this.state.documentlist);
                    this.state.displaydoc = {
                        'FileUrl': '',
                        'ProjectDocumentId': 0,
                        'DocumentDate': '',
                        'DocumentName': '',
                        'Comments': ''
                    }
                    this.setState({})
                    this.props.navigate(`/correctiveaction`)
                    this.documents(this.state.documentlist);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    AttachFiles = () => {
        this.inputFile.current.click();
    };

    UploadFile = (e) => {
        let formData = new FormData()
        Array.from(e.target.files).forEach(async (a) => {
            formData.append("formFiles", a)
        })
        this.Upload_File(this.state.postdocs, formData)
    }

    Upload_File = (data, formData) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/ProcessDocument?ActionBy=' + data.ActionBy + '&ActionDate=' + data.ActionDate + '&ProjectDocumentId=' + data.ProjectDocumentId + '&ProjectId=' + data.ProjectId + '&DocumentDate=' + data.DocumentDate + '&TypeId=' + data.TypeId + '&ProjectDocumentTypeId=' + data.ProjectDocumentTypeId;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: formData,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.documents(this.state.documentlist);
                    this.props.navigate(`/correctiveaction`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    handleInputChange2 = (e, val) => {
        this.state.displaydoc.Comments = e.target.value;
        this.setState({})
    }
    updatecomments = (e, val) => {

        let data = {
            "Projectdocumentsid": val.ProjectDocumentId,
            "Comments": val.Comments.trim(),
            "Status": val.Status,
            "ActionBy": this.state.UserRole,
            "DocumentDate": val.DocumentDate
        }
        this.put_comments(data)
    }

    put_comments = (data) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/UpdateDocumentField';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.documents(this.state.documentlist);
                    this.dataTable(this.state.tableData);
                    this.props.navigate(`/correctiveaction`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    render() {
        let { classes, menuToggle, yardauditdocnames } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-5 w-50 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Corrective" + "1"} className=' textNaviIcon' primary="Yard Documents" />
                                            <NavigateNextIcon id="Corrective" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-7 pt-2 mt-5 w-50">
                                    <h4 className="pt-2">Corrective Actions</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row">
                        <div>
                            <AppBar position="static" color="inherit" className={classes.root} style={{ margin: '0', maxHeight: '0px', paddingLeft: '25px' }}>
                                <Tabs
                                    value={this.state.value}
                                    onChange={this.handleChange}
                                    classes={{ indicator: classes.indicator }}
                                >
                                    <Tab className="f-size-12" style={{ textTransform: "none", minWidth: '13px' }} label="Corrective Actions" {...a11yProps(0)} />
                                    <Tab className="f-size-12 " style={{ textTransform: "none", minWidth: '13px' }} label="History Log" {...a11yProps(1)} />
                                </Tabs>
                            </AppBar>
                            <TabPanel value={this.state.value} index={0}>
                                <div className="col-12 mt-4 pt-2 px-0">
                                    <div className="table-responsive" style={{ width: "100%" }}>
                                        <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                            <thead>
                                                <tr className="table-active">
                                                    <th width="3%" className="border-right"><span className="spandoc-thead">S.No</span></th>
                                                    <th width="30%" className="border-right"><span className="spandoc-thead">Document</span></th>
                                                    <th className="border-right spandate-thead"><span className="spandoc-thead Nowrap">Created On</span></th>
                                                    <th className="comments-td"><span className="spandoc-thead">Comments</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.render == true ?
                                                    <tr className="border-top">
                                                        <td width="3%" className="border-right text-center align-middle"><span className="spandoc-td">1</span></td>
                                                        <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td" : "docwidth-td"} border-right align-middle`}>
                                                            <div className="col-12 m-0 p-0 row">
                                                                <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 overflow pl-0">
                                                                    <span className="spandoc-td">{this.state.displaydoc.DocumentName && this.state.displaydoc.DocumentName}</span>
                                                                </div>
                                                                <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 p-0 space-doc">
                                                                    {this.state.displaydoc.FileUrl && this.state.displaydoc.FileUrl != "" ? <>
                                                                        <button className="completed-button">COMPLETED</button>
                                                                        <a href={this.state.displaydoc.FileUrl} target="_blank" className="link-colors pl-2">
                                                                            <img src={View} className="cursorPointer pl-1 viewdel-td" />
                                                                            <span className="pl-1 cursorPointer link-color">View</span></a>
                                                                        {this.state.UserRole === "ShipOwner" ? <></> : <>
                                                                            <img src={Delete} className="pl-2 cursorPointer viewdel-td" onClick={() => { this.OpenPopup(this.state.displaydoc.ProjectDocumentId) }} />
                                                                            <span className="pl-1 cursorPointer" onClick={() => { this.OpenPopup(this.state.displaydoc.ProjectDocumentId) }}>Delete</span> </>}</> : <>
                                                                        <button className="pending-button mr-1">PENDING</button>
                                                                        <img src={upload} className="cursorPointer ml-4 uploadicon-td" onChange={(e) => this.UploadFile(e)} onClick={() => this.AttachFiles()} />
                                                                        <span className="pl-1 mr-5 cursorPointer" onChange={(e) => this.UploadFile(e)} onClick={() => this.AttachFiles()}>Upload</span>
                                                                        <input
                                                                            type="file"
                                                                            hidden
                                                                            multiple
                                                                            onChange={(e) => this.UploadFile(e)}
                                                                            ref={this.inputFile}
                                                                        />
                                                                    </>}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="spandate-thead border-right align-middle">
                                                            <span className="spandoc-td">{this.state.displaydoc.DocumentDate && moment(this.state.displaydoc.DocumentDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</span>
                                                        </td>
                                                        <td className={`${window.innerWidth < 1080 ? "commentsmobile-td" : "comments-td"} align-middle`}>
                                                            {this.state.displaydoc.DocumentName && this.state.displaydoc.DocumentName != "" ?
                                                                // <CssTextField
                                                                //     multiline
                                                                //     fullWidth
                                                                //     disabled
                                                                //     variant="outlined"
                                                                //     type="text"
                                                                //     value={this.state.displaydoc.Comments && this.state.displaydoc.Comments}
                                                                //     InputProps={{
                                                                //         className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                //     }}
                                                                // /> :
                                                                <CssTextField
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    onBlur={(e) => this.updatecomments(e, this.state.displaydoc)}
                                                                    value={this.state.displaydoc.Comments && this.state.displaydoc.Comments}
                                                                    onChange={(e) => this.handleInputChange2(e, this.state.displaydoc)}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                    }}
                                                                /> : ""}
                                                        </td>
                                                    </tr> : ""}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel value={this.state.value} index={1}>
                                <div className="row mt-4 pt-2">
                                    <div className="col-sm-12 col-12">
                                        <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                            <table className="table table-borderless">
                                                <thead>
                                                    <tr className="border-bottom">
                                                        <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '160px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                                        <th className="border-top border-right" style={{ width: '10%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                        <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                                        <th className="border-top border-right" style={{ width: '60%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ fontFamily: 'Segoe UI' }}>
                                                    {this.props.historyLog && this.props.historyLog.map((i) => (
                                                        <tr className="border-bottom">
                                                            <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                                {moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                            </td>
                                                            <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                            <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                            <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "" : "10%" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>

                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" onClick={() => { window.$("#deletepopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        historyLog: state.commonReducer.historyLog || [],
    };
}

CorrectiveAction.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CorrectiveAction)));